"use client";

import { useState } from "react";
import { motion } from "motion/react";
import { COLORS } from "@/lib/data";
import { Reveal } from "./Reveal";

export function ColorStudio() {
  const [color, setColor] = useState(COLORS[0]);

  return (
    <section className="bg-paper px-5 py-24 md:px-8 md:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <p className="text-xs tracking-[0.22em] uppercase">StoColor System</p>
          <h2 className="font-display mt-4 text-4xl leading-[0.95] md:text-6xl">
            Peindre
            <br />
            le volume.
          </h2>
          <p className="mt-6 max-w-md text-mute">
            1 000 teintes façade. Cliquez une couleur — le bâtiment change de peau.
            C’est ça, concevoir une enveloppe.
          </p>
          <p className="mt-8 font-mono text-sm">
            {color.name} · {color.hex}
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative">
            <svg viewBox="0 0 480 420" className="w-full drop-shadow-2xl">
              <rect width="480" height="420" fill="#d8d2c6" />
              <motion.rect
                x="70"
                y="70"
                width="340"
                height="280"
                fill={color.hex}
                animate={{ fill: color.hex }}
                transition={{ duration: 0.6 }}
              />
              <rect x="70" y="70" width="340" height="18" fill="#0b0b0b" opacity="0.12" />
              <rect x="92" y="110" width="70" height="90" fill="#f7f4ee" opacity="0.55" />
              <rect x="178" y="110" width="70" height="90" fill="#f7f4ee" opacity="0.55" />
              <rect x="264" y="110" width="70" height="90" fill="#f7f4ee" opacity="0.55" />
              <rect x="92" y="218" width="70" height="90" fill="#f7f4ee" opacity="0.4" />
              <rect x="178" y="218" width="70" height="90" fill="#f7f4ee" opacity="0.4" />
              <rect x="264" y="218" width="70" height="90" fill="#f7f4ee" opacity="0.4" />
              <rect x="348" y="218" width="40" height="132" fill="#0b0b0b" opacity="0.18" />
              <rect x="40" y="350" width="400" height="12" fill="#0b0b0b" />
            </svg>
          </div>
        </Reveal>
      </div>

      <div className="mx-auto mt-12 grid max-w-7xl grid-cols-4 gap-3 md:grid-cols-6 lg:grid-cols-12">
        {COLORS.map((c) => (
          <button
            key={c.hex}
            type="button"
            data-cursor="hover"
            onClick={() => setColor(c)}
            className="group aspect-square overflow-hidden rounded-sm"
            style={{ background: c.hex }}
            aria-label={c.name}
          >
            <span
              className={`block h-full w-full ring-2 ring-inset transition ${
                color.hex === c.hex ? "ring-ink" : "ring-transparent group-hover:ring-ink/30"
              }`}
            />
          </button>
        ))}
      </div>
    </section>
  );
}
